module.exports = __webpack_public_path__ + "img/w3_reload_black.f66bd28c.png";